import { API } from 'widget/helpers/axios';

const buildUrl = endPoint => `/api/v1/${endPoint}${window.location.search}`;

export default {
  async get() {
    console.log('BEFORE GET Contact API :');
    const result = await API.get(buildUrl('widget/contact'));
    console.log('CONTACT status ', result.statusText);
    return result;
    // API.get(`/api/v1/widget/contact${window.location.search}`)
    //   .then(response => {
    //     // let contact = response.data;
    //     console.log('Contact RESULT API =', response.data);
    //     return response;
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
  },
  update(userObject) {
    return API.patch(buildUrl('widget/contact'), userObject);
  },
  setUser(identifier, userObject) {
    return API.patch(buildUrl('widget/contact/set_user'), {
      identifier,
      ...userObject,
    });
  },
  setCustomAttributes(customAttributes = {}) {
    return API.patch(buildUrl('widget/contact'), {
      custom_attributes: customAttributes,
    });
  },
  deleteCustomAttribute(customAttribute) {
    return API.post(buildUrl('widget/contact/destroy_custom_attributes'), {
      custom_attributes: [customAttribute],
    });
  },
};
